import "../styles/confirm-delete-modal.scss";
import { Modal } from "./modal";
import { GuiButton } from "./global-ui/gui-button";
import { Spinner } from "./loading-spinner";

export function ConfirmDeleteModal({
  dataQa,
  status,
  onDelete,
  onCancel,
  deleting,
  title,
  message,
  confirmText,
  cancelText,
  className,
  showClose,
}) {
  let text = title || "";
  let furtherText = message || "";
  let buttonText = confirmText || "";

  if (!text && status === "discard") {
    text = "Are you sure you want to discard your Message?";
    furtherText = "All unsaved changes will be lost.";
    buttonText = "Discard Message";
  } else if (!text && status === "remove") {
    text = "Are you sure you want to do this?";
    buttonText = "Delete";
  }

  if (deleting) buttonText = <Spinner />;

  return (
    <Modal className={`confirm-delete-modal ${className || ""}`.trim()}>
      {showClose && (
        <button type="button" className="close-button" onClick={onCancel}>
          ×
        </button>
      )}
      <div className="icon-container">
        <i
          className="fa fa-exclamation-triangle warning-icon"
          aria-hidden="true"
        />
      </div>
      <h4 className="title">{text}</h4>
      {furtherText && <h6 className="further-text">{furtherText}</h6>}
      <div className="btn-container">
        <GuiButton dataQa="cancel" className="btn-outline" onClick={onCancel}>
          {cancelText || "Cancel"}
        </GuiButton>
        <GuiButton
          dataQa="other"
          className="warning"
          onClick={(e) => {
            e.preventDefault();
            onDelete();
          }}
        >
          {buttonText}
        </GuiButton>
      </div>
    </Modal>
  );
}
